import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import PatientRelativesInformationPage from '../views/patientInformation/patientRelativesInformationPage'

const PatientRelativesInformation = () => {
    window.scrollTo(0, 0);

    return (
        <>
            <Header />
            <PatientRelativesInformationPage />
            <Footer />
        </>
    )
}

export default PatientRelativesInformation
